"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _pressability = require("../utils/pressability");
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectGeneralBubbleTokens = _ref => {
  let {
    outerBubbleHeight,
    outerBubbleWidth,
    outerBubbleContentAlignItems,
    outerBubbleJustifyContent,
    bubbleBorderColor,
    bubbleBorderWidth,
    bubbleBorderRadius
  } = _ref;
  return {
    height: outerBubbleHeight,
    width: outerBubbleWidth,
    justifyContent: outerBubbleContentAlignItems,
    alignItems: outerBubbleJustifyContent,
    borderColor: bubbleBorderColor,
    borderWidth: bubbleBorderWidth,
    borderRadius: bubbleBorderRadius,
    ..._Platform.default.select({
      web: {
        outline: 'none'
      }
    })
  };
};
const selectInnerBubbleTokens = _ref2 => {
  let {
    innerBubbleHeight,
    innerBubbleWidth,
    innerBubbleBorderRadius,
    borderColor,
    borderWidth,
    shadow
  } = _ref2;
  return {
    height: innerBubbleHeight,
    width: innerBubbleWidth,
    borderRadius: innerBubbleBorderRadius,
    borderColor,
    borderWidth,
    ...(0, _ThemeProvider.applyShadowToken)(shadow)
  };
};
const selectBorderBubbleTokens = _ref3 => {
  let {
    bubbleBorderColor,
    bubbleBorderWidth,
    bubbleBorderRadius
  } = _ref3;
  return {
    borderColor: bubbleBorderColor,
    borderWidth: bubbleBorderWidth,
    borderRadius: bubbleBorderRadius
  };
};
const ColourBubble = /*#__PURE__*/_react.default.forwardRef((_ref4, ref) => {
  let {
    tokens = {},
    id,
    colourHexCode,
    colourName,
    isSelected,
    onPress
  } = _ref4;
  const defaultTokens = tokens({
    selected: isSelected
  });
  const resolveColourBubbleTokens = pressState => (0, _pressability.resolvePressableTokens)(tokens, pressState, {});
  const themeTokens = _react.default.useMemo(() => tokens(), [tokens]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    style: state => [selectGeneralBubbleTokens(resolveColourBubbleTokens(state)), isSelected && selectBorderBubbleTokens(defaultTokens)],
    onPress: onPress,
    accessible: true,
    accessibilityRole: "radio",
    accessibilityLabel: colourName,
    accessibilityState: {
      checked: isSelected
    },
    ref: ref,
    testID: id,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: [selectInnerBubbleTokens(themeTokens), {
        backgroundColor: colourHexCode
      }]
    })
  });
});
ColourBubble.displayName = 'ColourBubble';
ColourBubble.propTypes = {
  /**
   * Colour toggle tokens callback.
   */
  tokens: (0, _utils.getTokensPropType)('ColourToggle'),
  /**
   * ID of each colour bubble
   */
  id: _propTypes.default.string,
  /**
   * Hexadecimal code for the background of the colour bubble
   */
  colourHexCode: _propTypes.default.string,
  /**
   * Name of the colour bubble
   */
  colourName: _propTypes.default.string,
  /**
   * If the current colour bubble is selected
   */
  isSelected: _propTypes.default.bool,
  /**
   * If provided, this function is called when the current selection
   * of the color is changed of all currently `items`.
   * Receives two parameters: item object selected and the event
   */
  onPress: _propTypes.default.func
};
var _default = exports.default = ColourBubble;